import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../_services/shared.service';
import { AuthService } from '../../_services/auth.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, fromEvent, map, Observable, shareReplay } from 'rxjs';

import { ThemeService } from '../../_services/theme.service';

import { MatCardModule } from '@angular/material/card';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LxResponsiveClassDirective } from '../../directives/lx-responsive-class.directive';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-offer-confirmation-validation-sent',
    standalone: true,
    imports: [
  CommonModule,
    MatCardModule,
    NgxSpinnerModule,
    LxResponsiveClassDirective
],
    templateUrl: './offer-confirmation-validation-sent.component.html',
    styleUrl: './offer-confirmation-validation-sent.component.scss'
})
export class OfferConfirmationValidationSentComponent implements OnInit, AfterViewInit  {

    private propertyId: string = '';
    private offerAliasId: string = '';

    offerError: boolean = false;
    offerRefresh: boolean = false;

    @ViewChild('cardButton') button: any;
    tokenButton$!: Observable<any>;

    resendButtonEnabled: boolean = true;
  themeReady: boolean = false;


    constructor(public sharedService: SharedService,
                private authService: AuthService,
                private router: Router,
                private route: ActivatedRoute,
                private themeService: ThemeService) {
    }

  ngOnInit(): void {
    this.themeReady = false;

    if(localStorage.getItem('offerError')){
      if(localStorage.getItem('offerError') === 'true' && localStorage.getItem('error_offer_alias_id') === this.offerAliasId){
        this.offerError = true;
        this.router.navigate(['/offerNotAvailable']);
      } else {
        this.offerError = false;
        localStorage.setItem('offerError', 'false');
        localStorage.setItem('error_offer_alias_id', '');
      }
    }
    this.propertyId = this.route.snapshot.paramMap.get('prop_id') ? this.route.snapshot.paramMap.get('prop_id') as string : '';
    this.offerAliasId = this.route.snapshot.paramMap.get('alias_id') ? this.route.snapshot.paramMap.get('alias_id') as string : '';

    this.waitForThemeReady();

    const prestayTheme = this.sharedService.applicationConfig?.prestay?.theme;
    this.themeService.restorePersistedThemeOrApply(prestayTheme, 'zen').finally(() => {
      this.themeReady = this.themeService.isThemeReady();
    });
  }

  ngAfterViewInit(): void {

    if (!this.button?.nativeElement) {
      this.tokenButton$ = EMPTY;
      return;
    }

    this.tokenButton$ = fromEvent(this.button.nativeElement, 'click').pipe(
      shareReplay(1),
      map(() => this.authService.requestUpgradeConfirmationValidation(this.offerAliasId,
                                                                      this.propertyId,
                                                                      this.sharedService.offer.offer_set_id,
                                                                      this.sharedService.offer.offer_id,
                                                                      this.sharedService.offer.base_room_category_name,
                                                                      this.sharedService.offer.bar_price).subscribe())
    );
    this.tokenButton$.subscribe();

  }

  ngOnDestroy(): void {
    this.offerError = false;
    localStorage.setItem('offerError', 'false');
    localStorage.setItem('error_offer_alias_id', '');

  }

  private waitForThemeReady(): void {
    this.themeReady = this.themeService.isThemeReady();

    if (this.themeReady) {
      return;
    }

    this.themeService.themeReady$.subscribe(isReady => {
      this.themeReady = isReady;
    });
  }
}
